import { c as _c } from "react/compiler-runtime";
import { LiveChat } from '@bolddesk/live-chat-web-sdk';
import { LocaleEnum } from '@systemeio/ui';
import { useEffect } from 'react';
interface BoldDeskProps {
  shouldRender: boolean;
  locale: LocaleEnum;
}
export function BoldDesk(t0) {
  const $ = _c(4);
  const {
    shouldRender,
    locale
  } = t0;
  let t1;
  let t2;
  if ($[0] !== locale || $[1] !== shouldRender) {
    t1 = () => {
      if (shouldRender) {
        LiveChat.configure("cfb6c538-17e0-4aea-b782-33ff907747c3", "https://systemeio.bolddesk.com", {
          locale
        });
        LiveChat.showWidget();
      } else {
        LiveChat.hideWidget();
      }
    };
    t2 = [shouldRender, locale];
    $[0] = locale;
    $[1] = shouldRender;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return null;
}